/**
 * The below file contains the infrastruture other damage state objects
 * @author: neeraj.singh.rawat@velsof.com
 * @date : 14-11-2022
 */
import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  ADD_INFOTHERDAMAGE,
  EDIT_INFOTHERDAMAGE,
  SET_INFOTHERDAMAGE,
  SET_INFOTHERDAMAGE_LISTING_PARAM,
  SET_INFOTHERDAMAGE_LISTING,
  UPDATE_INFOTHERDAMAGE_STATUS,
  SET_EXPORT_INFOTHERDAMAGE_DATA,
  GET_EXPORT_INFOTHERDAMAGE_DATA,
} from "../constants/InfOtherDamage";

//Initial state
const initState = {
  //Keys for infOtherDamage listing
  infOtherDamageList: {},
  isInfOtherDamageDataFetched: false,
  token: localStorage.getItem(AUTH_TOKEN),
  infOtherDamageListingParam: {},
  infOtherDamageExportedData: {},
  //Keys for infOtherDamage listing

  //Keys for infOtherDamage add page
  addInfOtherDamageForm: {},
  //Keys for infOtherDamage add page

  //Keys for infOtherDamage edit page
  infOtherDamageFormData: {},
  //Keys for infOtherDamage edit page
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const infOtherDamage = (state = initState, action) => {
  switch (action.type) {
    //Cases for InfOtherDamage listing
    case SET_INFOTHERDAMAGE_LISTING:
      return {
        ...state,
        infOtherDamageList: action.payload,
        isInfOtherDamageDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_INFOTHERDAMAGE_LISTING_PARAM:
      return {
        ...state,
        infOtherDamageListingParam: action.payload,
      };

    case UPDATE_INFOTHERDAMAGE_STATUS:
      let updateInfOtherDamageListData = {
        ...state.infOtherDamageList,
        data: state.infOtherDamageList.data?.map((item) => {
          if (item.id === action.payload.id) {
            item.status = action.payload.status;
          }
          return item;
        }),
      };
      return {
        ...state,
        infOtherDamageList: updateInfOtherDamageListData,
      };

    case GET_EXPORT_INFOTHERDAMAGE_DATA:
      return {
        ...state,
      };

    case SET_EXPORT_INFOTHERDAMAGE_DATA:
      return {
        ...state,
        infOtherDamageExportedData: action.payload,
      };
    //Cases for InfOtherDamage listing

    //Cases for InfOtherDamage add page
    case ADD_INFOTHERDAMAGE:
      return {
        ...state,
        addInfOtherDamageForm: action.payload,
      };
    //Cases for InfOtherDamage add page

    //Cases for InfOtherDamage edit page
    case EDIT_INFOTHERDAMAGE:
      return {
        ...state,
        addInfOtherDamageForm: action.payload,
      };
    case SET_INFOTHERDAMAGE:
      return {
        ...state,
        infOtherDamageFormData: action.payload,
      };
    //Cases for InfOtherDamage edit page

    default:
      return state;
  }
};

export default infOtherDamage;
